import Button from '../../../../../components/Button/Button';
import Figure from '../../../../../components/Figure/Figure';
import Paragraph from '../../../../../components/Paragraph/Paragraph';
import Row from '../../../../../components/Row/Row';
import Stack from '../../../../../components/Stack/Stack';
import useTrans from '../../../../../hooks/ui/useTrans';
import DockWithMedia from '../../../../types/DockWithMedia';
import placeholderImage from '../../graphics/dockPlaceholder.svg';
import OnlySingleOrMultiDayMessage from '../OnlySingleOrMultiDayMessage/OnlySingleOrMultiDayMessage';
import TintOnHoverButton from '../TintOnHoverButton/TintOnHoverButton';

import styles from './DockCard.module.css';

type DockCardProps = {
    dock: DockWithMedia;
    onSelect: (dock: DockWithMedia) => void;
    onPreview: (dock: DockWithMedia) => void;
    incompatibleSingleOrMultiDay?: boolean;
};

const DockCard = ({
    dock,
    onSelect,
    onPreview,
    incompatibleSingleOrMultiDay,
}: DockCardProps) => {
    const trans = useTrans('CustomerArea.BookingForm.DockCard.');
    const handleSelect = () => onSelect(dock);
    const handleFigureClicked = () => onPreview(dock);

    const thumbPath = dock.media[0]?.variants.thumb.path;

    return (
        <div className={styles.Root}>
            <TintOnHoverButton
                onClick={handleFigureClicked}
                fullWidth
                borderRadius="top"
                disabled={incompatibleSingleOrMultiDay}
            >
                <Figure
                    borderRadius="top"
                    defaultPlaceholderRatio={0.5}
                    caption={dock.name}
                    captionPosition="inside"
                    src={thumbPath ?? placeholderImage}
                    vignette={thumbPath ? 'bottomLeft' : undefined}
                    saturation={incompatibleSingleOrMultiDay ? 0 : 1}
                />
            </TintOnHoverButton>

            <div className={styles.Content}>
                <Row horizontal="justify" vertical="bottom">
                    <Stack space="none">
                        <Paragraph size="small">{dock.address.city}</Paragraph>
                        <Paragraph size="small" subdued>
                            {dock.address.line1}
                        </Paragraph>
                    </Stack>

                    <Button
                        onClick={handleSelect}
                        disabled={incompatibleSingleOrMultiDay}
                    >
                        {trans('ChooseButton')}
                    </Button>
                </Row>
            </div>

            <OnlySingleOrMultiDayMessage
                show={!!incompatibleSingleOrMultiDay}
                singleOrMultiDay={dock.singleOrMultiDay}
            />
        </div>
    );
};

export default DockCard;
